import { Link } from 'react-router-dom';
import { getTokenValue, XStack, Token } from 'tamagui';
import { hexToRGBA } from 'tamagui-config';

const SidebarButton = ({
  to,
  isActive,
  icon: Icon,
}: {
  to: string;
  isActive: boolean;
  icon: React.ComponentType<{ size: number; color: string }>;
}) => {
  const gradientStartColor = getTokenValue('$hgPrimaryGradientStart' as Token, 'color');
  const gradientEndColor = getTokenValue('$hgPrimaryGradientEnd' as Token, 'color');
  const elevatedShadowColor = getTokenValue('$hgPrimary' as Token, 'color');

  const gradient = `linear-gradient(106deg, ${gradientStartColor} 0%, ${gradientEndColor} 100%)`;
  const boxShadow = `0px 4px 24px 0px ${hexToRGBA(elevatedShadowColor, 0.25)}`;
  return (
    <Link
      to={to}
      style={{
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      }}>
      <XStack
        flex={1}
        height={92}
        backgroundImage={isActive ? gradient : undefined}
        boxShadow={isActive ? boxShadow : undefined}
        borderRadius={46}
        alignItems="center"
        justifyContent="center">
        <Icon size={48} color={isActive ? '$white' : '$hgPrimary'} />
      </XStack>
    </Link>
  );
};

export { SidebarButton };
